import { forwardRef } from 'react'

import { useDeviceScreen } from '@canyon/ui/hooks'
import { cn } from '@canyon/ui/utils'
import { cva } from 'class-variance-authority'

import { SidebarToggle } from '@/components/SidebarToggle'
import { useSidebar } from '@/provider/SidebarProvider'

const toolbarVariants = cva('flex flex-row text-sm items-center w-full', {
  defaultVariants: {
    align: 'center',
    justify: 'between',
  },
  variants: {
    align: {
      center: 'items-center',
      end: 'items-end',
      start: 'items-start',
    },
    justify: {
      between: 'justify-between',
      end: 'justify-end',
      start: 'justify-start',
    },
  },
})

export interface IToolbarProps extends React.HTMLAttributes<HTMLDivElement> {
  align?: 'center' | 'end' | 'start'
  borderBottom?: boolean
  justify?: 'between' | 'end' | 'start'
  showSidebarToggle?: boolean
}

export const Toolbar = forwardRef<HTMLDivElement, IToolbarProps>(
  (
    {
      align,
      borderBottom = true,
      children,
      className,
      justify,
      showSidebarToggle = true,
      ...props
    },
    ref
  ) => {
    const { isSidebarOpen } = useSidebar()
    const { isMobile } = useDeviceScreen()
    return (
      <div
        className={cn(
          'flex h-[52px] md:h-[45px] items-center gap-2 px-2',
          borderBottom ? 'border-border border-b-[0.5px]' : null,
          className
        )}
        ref={ref}
        {...props}
      >
        <div className={cn(toolbarVariants({ align, justify }), className)}>{children}</div>
      </div>
    )
  }
)

Toolbar.displayName = 'Toolbar'
